<template>
  <div>
    <v-btn text
           @click.stop="dialog = true"
    >
      Add user
    </v-btn>
    <v-dialog v-model="dialog"
              max-width="500"
              persistent
    >
      <AddUserToGroupForm
        v-if="dialog"
        :connection="connection"
        :group="group"
        @cancel="dialog = false"
        @ok="dialog = false"
        @groups-updated="$emit('groups-updated', $event)"
        @failure="$emit('failure', $event)"
      ></AddUserToGroupForm>
    </v-dialog>
  </div>
</template>

<script>
import AddUserToGroupForm from "./AddUserToGroupForm";
import { HubConnection } from "@microsoft/signalr";

export default {
  name:       "AddUserToGroup",
  components: { AddUserToGroupForm },
  props:      {
    connection: HubConnection,
    group:      Object,
  },
  data: () => ({
    dialog: false,
  }),
};
</script>

<style scoped></style>
